import { EP } from './../configs/constant';
import { getPath } from "../helpers/handleUrl";
import { IShopConfigInfoResponse } from "../types/shop";
import axiosService, { AxiosService } from './axiosService';
class ShopService {
    readonly service: AxiosService;
    constructor() {
        this.service = axiosService;
    }
    getShopConfigInfo() {
        return this.service.get<IShopConfigInfoResponse>(getPath(EP.SHOP, EP.STORE))
    }
}
const shopService = new ShopService();
export default shopService;